export const componentRenderCheck = (condition, conditionStateValue, journeyContext) => {

  // console.log(condition, conditionStateValue, "inside function")
  let stateValue  
  if(condition.journeyContextCheck === true){
    let keyArr = condition.watchKey.split(".")
    let wValue = journeyContext
    if(keyArr.length > 0){
      for(let i=0;i<keyArr.length;i++){
        if(!wValue){
          break
        }
        wValue = wValue[keyArr[i]]
        stateValue = wValue
      }
    }
  }else{
    stateValue = conditionStateValue
  }

  if (condition.type === "yesNo") {
    if (condition.condition === "equalTo") {
      if (condition.watchValue === stateValue) {
        return true
      }
    } else if (condition.condition === "notEqualTo") {
      if (condition.watchValue !== stateValue) {
        return false
      }
    }
  }
  else if (condition.type === "value") {
    if (condition.condition === "equalTo") {
      if (condition.watchValue === stateValue) {
        return true
      }
    } else if (condition.condition === "notEqualTo") {
      if (!stateValue && condition.conditionName !== "taxResidencyCountry") {
        return false
      }
      else if (condition.watchValue === stateValue) {
        return false
      } else {
        return true
      }
    }
  } else if (condition.type === "age") {
    if (condition.condition === "lessThan") {
      if (Array.isArray(stateValue)) {
        let ages = stateValue.map(element => {
          let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
          let timeleft = currentDateInEpoch - element
          let days = Math.ceil(((timeleft / 60) / 60) / 24)
          return days
        })
        return ages.some(age => age < condition.watchValue)

      } else {
        let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
        let timeleft = currentDateInEpoch - conditionStateValue
        let days = Math.ceil(((timeleft / 60) / 60) / 24)
        return days < condition.watchValue
      }
    }else if (condition.condition === "greaterThan"){
       if (Array.isArray(stateValue)) {
        let ages = stateValue.map(element => {
          let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
          let timeleft = currentDateInEpoch - element
          let days = Math.ceil(((timeleft / 60) / 60) / 24)
          return days
        })
        return ages.some(age => age > condition.watchValue)

      } else {
        let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
        let timeleft = currentDateInEpoch - conditionStateValue
        let days = Math.ceil(((timeleft / 60) / 60) / 24)
        return days > condition.watchValue
      }
    }
  }

}

export const multiConditionComponentRenderCheck = (conditions, conditionState, journeyContext) => {
  console.log("multiPleCondition", conditionState, conditions)
  if(conditions[0].hasOwnProperty("attributes")){
    if (conditions[0]?.["attributes"]?.multipleCondition === "and") {
      let toPass = conditions.every(condition => {
        let stateValue
        let conditionStateValue = conditionState[condition.attributes.watchKey]
        if (condition.attributes.journeyContextCheck === true) {
          let keyArr = condition.attributes.watchKey.split(".")
          let wValue = journeyContext
          if (keyArr.length > 0) {
            for (let i = 0; i < keyArr.length; i++) {
              if (!wValue) {
                break
              }
              wValue = wValue[keyArr[i]]
              stateValue = wValue
            }
          }
        } else {
          stateValue = conditionStateValue
        }
        if (condition.attributes.type === "yesNo") {
          if (condition.attributes.condition === "equalTo") {
            if (condition.attributes.watchValue === stateValue) {
              return true
            }
          } else if (condition.attributes.condition === "notEqualTo") {
            if (condition.attributes.watchValue !== stateValue) {
              return false
            }
          }
        }
        else if (condition.attributes.type === "value") {
          if (condition.attributes.condition === "equalTo") {
            if (condition.attributes.watchValue === stateValue) {
              return true
            }
          } else if (condition.attributes.condition === "notEqualTo") {
            if (!stateValue) {
              return false
            }
            else if (condition.attributes.watchValue === stateValue) {
              return false
            } else {
              return true
            }
          }
        } else if (condition.attributes.type === "age") {
          if (condition.attributes.condition === "lessThan") {
            if (Array.isArray(stateValue)) {
              let ages = stateValue.map(element => {
                let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
                let timeleft = currentDateInEpoch - element
                let days = Math.ceil(((timeleft / 60) / 60) / 24)
                return days
              })
              return ages.some(age => age < condition.attributes.watchValue)

            } else {
              let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
              let timeleft = currentDateInEpoch - stateValue
              let days = Math.ceil(((timeleft / 60) / 60) / 24)
              return days < condition.attributes.watchValue
            }
          }
        }
      })
      return toPass
    } else if (conditions[0]?.["attributes"]?.multipleCondition === "or") {
      let toPass = conditions.some(condition => {
        let stateValue
        let conditionStateValue = conditionState[condition.attributes.watchKey]
        if (condition.attributes.journeyContextCheck === true) {
          let keyArr = condition.attributes.watchKey.split(".")
          let wValue = journeyContext
          if (keyArr.length > 0) {
            for (let i = 0; i < keyArr.length; i++) {
              if (!wValue) {
                break
              }
              wValue = wValue[keyArr[i]]
              stateValue = wValue
            }
          }
        } else {
          stateValue = conditionStateValue
        }
        if (condition.attributes.type === "yesNo") {
          if (condition.attributes.condition === "equalTo") {
            if (condition.attributes.watchValue === stateValue) {
              return true
            }
          } else if (condition.attributes.condition === "notEqualTo") {
            if (condition.attributes.watchValue !== stateValue) {
              return false
            }
          }
        }
        else if (condition.attributes.type === "value") {
          if (condition.attributes.condition === "equalTo") {
            if (condition.attributes.watchValue === stateValue) {
              return true
            }
          } else if (condition.attributes.condition === "notEqualTo") {
            if (!stateValue) {
              return false
            }
            else if (condition.attributes.watchValue === stateValue) {
              return false
            } else {
              return true
            }
          }
        } else if (condition.attributes.type === "age") {
          if (condition.attributes.condition === "lessThan") {
            if (Array.isArray(stateValue)) {
              let ages = stateValue.map(element => {
                let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
                let timeleft = currentDateInEpoch - element
                let days = Math.ceil(((timeleft / 60) / 60) / 24)
                return days
              })
              return ages.some(age => age < condition.attributes.watchValue)

            } else {
              let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
              let timeleft = currentDateInEpoch - stateValue
              let days = Math.ceil(((timeleft / 60) / 60) / 24)
              return days < condition.attributes.watchValue
            }
          }
        }
      })
      return toPass
    } else {
      return false
    }
  }else{
    if (conditions[0].multipleCondition === "and") {
      let toPass = conditions.every(condition => {
        let stateValue  
        let conditionStateValue = conditionState[condition.watchKey]
        if(condition.journeyContextCheck === true){
          let keyArr = condition.watchKey.split(".")
          let wValue = journeyContext
          if(keyArr.length > 0){
            for(let i=0;i<keyArr.length;i++){
              if(!wValue){
                break
              }
              wValue = wValue[keyArr[i]]
              stateValue = wValue
            }
          }
        }else{
          stateValue = conditionStateValue
        }
        if (condition.type === "yesNo") {
          if (condition.condition === "equalTo") {
            if (condition.watchValue === stateValue) {
              return true
            }
          } else if (condition.condition === "notEqualTo") {
            if (condition.watchValue !== stateValue) {
              return false
            }
          }
        }
        else if (condition.type === "value") {
          if (condition.condition === "equalTo") {
            if (condition.watchValue === stateValue) {
              return true
            }
          } else if (condition.condition === "notEqualTo") {
            if (!stateValue) {
              return false
            }
            else if (condition.watchValue === stateValue) {
              return false
            } else {
              return true
            }
          }
        } else if (condition.type === "age") {
          if (condition.condition === "lessThan") {
            if (Array.isArray(stateValue)) {
              let ages = stateValue.map(element => {
                let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
                let timeleft = currentDateInEpoch - element
                let days = Math.ceil(((timeleft / 60) / 60) / 24)
                return days
              })
              return ages.some(age => age < condition.watchValue)
  
            } else {
              let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
              let timeleft = currentDateInEpoch - stateValue
              let days = Math.ceil(((timeleft / 60) / 60) / 24)
              return days < condition.watchValue
            }
          }
        }
      })
      return toPass
    } else if (conditions[0].multipleCondition === "or") {
      let toPass = conditions.some(condition => {
        let stateValue  
        let conditionStateValue = conditionState[condition.watchKey]
        if(condition.journeyContextCheck === true){
          let keyArr = condition.watchKey.split(".")
          let wValue = journeyContext
          if(keyArr.length > 0){
            for(let i=0;i<keyArr.length;i++){
              if(!wValue){
                break
              }
              wValue = wValue[keyArr[i]]
              stateValue = wValue
            }
          }
        }else{
          stateValue = conditionStateValue
        }
        if (condition.type === "yesNo") {
          if (condition.condition === "equalTo") {
            if (condition.watchValue === stateValue) {
              return true
            }
          } else if (condition.condition === "notEqualTo") {
            if (condition.watchValue !== stateValue) {
              return false
            }
          }
        }
        else if (condition.type === "value") {
          if (condition.condition === "equalTo") {
            if (condition.watchValue === stateValue) {
              return true
            }
          } else if (condition.condition === "notEqualTo") {
            if (!stateValue) {
              return false
            }
            else if (condition.watchValue === stateValue) {
              return false
            } else {
              return true
            }
          }
        } else if (condition.type === "age") {
          if (condition.condition === "lessThan") {
            if (Array.isArray(stateValue)) {
              let ages = stateValue.map(element => {
                let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
                let timeleft = currentDateInEpoch - element
                let days = Math.ceil(((timeleft / 60) / 60) / 24)
                return days
              })
              return ages.some(age => age < condition.watchValue)
  
            } else {
              let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
              let timeleft = currentDateInEpoch - stateValue
              let days = Math.ceil(((timeleft / 60) / 60) / 24)
              return days < condition.watchValue
            }
          }
        }
      })
      return toPass
    }else{
      return false
    }
  }

  
}

export const repeatableMultiConditionComponentRenderCheck = (conditions, conditionState, journeyContext, arrayIndex) => {
  console.log("repeatableMultiConditionComponentRenderCheck", conditionState, conditions)
  if(conditions[0].hasOwnProperty("attributes")){
    if (conditions[0]?.["attributes"]?.multipleCondition === "and") {
      let toPass = conditions.every(condition => {
        let stateValue
        let conditionStateValue = conditionState[condition.attributes.watchKey]?.[arrayIndex]
        if (condition.attributes.journeyContextCheck === true) {
          let keyArr = condition.attributes.watchKey.split(".")
          let wValue = journeyContext
          if (keyArr.length > 0) {
            for (let i = 0; i < keyArr.length; i++) {
              if (!wValue) {
                break
              }
              wValue = wValue[keyArr[i]]
              stateValue = wValue
            }
          }
        } else {
          stateValue = conditionStateValue
        }
        if (condition.attributes.type === "yesNo") {
          if (condition.attributes.condition === "equalTo") {
            if (condition.attributes.watchValue === stateValue) {
              return true
            }
          } else if (condition.attributes.condition === "notEqualTo") {
            if (condition.attributes.watchValue !== stateValue) {
              return false
            }
          }
        }
        else if (condition.attributes.type === "value") {
          if (condition.attributes.condition === "equalTo") {
            if (condition.attributes.watchValue === stateValue) {
              return true
            }
          } else if (condition.attributes.condition === "notEqualTo") {
            if (!stateValue) {
              return false
            }
            else if (condition.attributes.watchValue === stateValue) {
              return false
            } else {
              return true
            }
          }
        } else if (condition.attributes.type === "age") {
          if (condition.attributes.condition === "lessThan") {
            if (Array.isArray(stateValue)) {
              let ages = stateValue.map(element => {
                let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
                let timeleft = currentDateInEpoch - element
                let days = Math.ceil(((timeleft / 60) / 60) / 24)
                return days
              })
              return ages.some(age => age < condition.attributes.watchValue)

            } else {
              let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
              let timeleft = currentDateInEpoch - stateValue
              let days = Math.ceil(((timeleft / 60) / 60) / 24)
              return days < condition.attributes.watchValue
            }
          }
        }
      })
      return toPass
    } else if (conditions[0]?.["attributes"]?.multipleCondition === "or") {
      let toPass = conditions.some(condition => {
        let stateValue
        let conditionStateValue = conditionState[condition.attributes.watchKey]
        if (condition.attributes.journeyContextCheck === true) {
          let keyArr = condition.attributes.watchKey.split(".")
          let wValue = journeyContext
          if (keyArr.length > 0) {
            for (let i = 0; i < keyArr.length; i++) {
              if (!wValue) {
                break
              }
              wValue = wValue[keyArr[i]]
              stateValue = wValue
            }
          }
        } else {
          stateValue = conditionStateValue
        }
        if (condition.attributes.type === "yesNo") {
          if (condition.attributes.condition === "equalTo") {
            if (condition.attributes.watchValue === stateValue) {
              return true
            }
          } else if (condition.attributes.condition === "notEqualTo") {
            if (condition.attributes.watchValue !== stateValue) {
              return false
            }
          }
        }
        else if (condition.attributes.type === "value") {
          if (condition.attributes.condition === "equalTo") {
            if (condition.attributes.watchValue === stateValue) {
              return true
            }
          } else if (condition.attributes.condition === "notEqualTo") {
            if (!stateValue) {
              return false
            }
            else if (condition.attributes.watchValue === stateValue) {
              return false
            } else {
              return true
            }
          }
        } else if (condition.attributes.type === "age") {
          if (condition.attributes.condition === "lessThan") {
            if (Array.isArray(stateValue)) {
              let ages = stateValue.map(element => {
                let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
                let timeleft = currentDateInEpoch - element
                let days = Math.ceil(((timeleft / 60) / 60) / 24)
                return days
              })
              return ages.some(age => age < condition.attributes.watchValue)

            } else {
              let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
              let timeleft = currentDateInEpoch - stateValue
              let days = Math.ceil(((timeleft / 60) / 60) / 24)
              return days < condition.attributes.watchValue
            }
          }
        }
      })
      return toPass
    } else {
      return false
    }
  }else{
    if (conditions[0].multipleCondition === "and") {
      let toPass = conditions.every(condition => {
        let stateValue  
        let conditionStateValue = conditionState[condition.watchKey]?.[arrayIndex]
        if(condition.journeyContextCheck === true){
          let keyArr = condition.watchKey.split(".")
          let wValue = journeyContext
          if(keyArr.length > 0){
            for(let i=0;i<keyArr.length;i++){
              if(!wValue){
                break
              }
              wValue = wValue[keyArr[i]]
              stateValue = wValue
            }
          }
        }else{
          stateValue = conditionStateValue
        }
        if (condition.type === "yesNo") {
          if (condition.condition === "equalTo") {
            if (condition.watchValue === stateValue) {
              return true
            }
          } else if (condition.condition === "notEqualTo") {
            if (condition.watchValue !== stateValue) {
              return false
            }
          }
        }
        else if (condition.type === "value") {
          if (condition.condition === "equalTo") {
            if (condition.watchValue === stateValue) {
              return true
            }
          } else if (condition.condition === "notEqualTo") {
            if (!stateValue) {
              return false
            }
            else if (condition.watchValue === stateValue) {
              return false
            } else {
              return true
            }
          }
        } else if (condition.type === "age") {
          if (condition.condition === "lessThan") {
            if (Array.isArray(stateValue)) {
              let ages = stateValue.map(element => {
                let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
                let timeleft = currentDateInEpoch - element
                let days = Math.ceil(((timeleft / 60) / 60) / 24)
                return days
              })
              return ages.some(age => age < condition.watchValue)
  
            } else {
              let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
              let timeleft = currentDateInEpoch - stateValue
              let days = Math.ceil(((timeleft / 60) / 60) / 24)
              return days < condition.watchValue
            }
          }
        }
      })
      return toPass
    } else if (conditions[0].multipleCondition === "or") {
      let toPass = conditions.some(condition => {
        let stateValue  
        let conditionStateValue = conditionState[condition.watchKey]
        if(condition.journeyContextCheck === true){
          let keyArr = condition.watchKey.split(".")
          let wValue = journeyContext
          if(keyArr.length > 0){
            for(let i=0;i<keyArr.length;i++){
              if(!wValue){
                break
              }
              wValue = wValue[keyArr[i]]
              stateValue = wValue
            }
          }
        }else{
          stateValue = conditionStateValue
        }
        if (condition.type === "yesNo") {
          if (condition.condition === "equalTo") {
            if (condition.watchValue === stateValue) {
              return true
            }
          } else if (condition.condition === "notEqualTo") {
            if (condition.watchValue !== stateValue) {
              return false
            }
          }
        }
        else if (condition.type === "value") {
          if (condition.condition === "equalTo") {
            if (condition.watchValue === stateValue) {
              return true
            }
          } else if (condition.condition === "notEqualTo") {
            if (!stateValue) {
              return false
            }
            else if (condition.watchValue === stateValue) {
              return false
            } else {
              return true
            }
          }
        } else if (condition.type === "age") {
          if (condition.condition === "lessThan") {
            if (Array.isArray(stateValue)) {
              let ages = stateValue.map(element => {
                let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
                let timeleft = currentDateInEpoch - element
                let days = Math.ceil(((timeleft / 60) / 60) / 24)
                return days
              })
              return ages.some(age => age < condition.watchValue)
  
            } else {
              let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
              let timeleft = currentDateInEpoch - stateValue
              let days = Math.ceil(((timeleft / 60) / 60) / 24)
              return days < condition.watchValue
            }
          }
        }
      })
      return toPass
    }else{
      return false
    }
  }

  
}